import React from "react";
import LuggageTooltip from "./LuggageTooltip";
import { isValid } from "../shared/utils";

const OutputLuggageInformation = props => {
	const hasTwoLuggages = props.luggageOutbound !== null && props.luggageInbound !== null;
	const isDifferentCompanies =
		(props.airlineInbound !== null && props.airlineOutbound !== props.airlineInbound) ||
		(props.pricing && props.pricing.inbound && props.pricing.outbound !== props.pricing.inbound);

	const luggageIsValid = flightLuggage => {
		return (
			isValid(props[flightLuggage]) &&
			isValid(props[flightLuggage].carryOn) &&
			isValid(props[flightLuggage].carryOn.weight) &&
			isValid(props[flightLuggage].checked)
		);
	};

	const setLuggageType = flight => {
		if (isValid(props[flight])) {
			return !isValid(props[flight].checked) || props[flight].checked.prices.length === 0
				? "buyOnCompanny"
				: props[flight].checked.prices[0] === 0 ? "included" : "buyOnMaxmilhas";
		}
	};

	const setLuggageStatus = (luggageType, flight) => {
		let luggageStatus;

		const luggageQuantity =
			flight === "luggageOutbound"
				? props.outboundLuggageQuantity
				: flight === "luggageInbound" ? props.inboundLuggageQuantity : props.luggageQuantity;

		switch (luggageType) {
			case "buyOnMaxmilhas":
				luggageStatus = "A INCLUIR";
				break;

			case "included":
				luggageQuantity === 0 && !props.isInternational
					? (luggageStatus = "A INCLUIR")
					: (luggageStatus = "INCLUÍDA");
				break;

			default:
				luggageStatus = props.isInternational ? "-" : "NÃO INCLUSA";
				break;
		}

		isValid(props.notIncluded) &&
		luggageStatus !== "INCLUÍDA" &&
		luggageStatus !== "-" &&
		(luggageType === "included" && luggageQuantity === 0)
			? (luggageStatus = "NÃO INCLUSA")
			: null;

		return luggageStatus;
	};

	const returnLuggageLine = (flightAirline, flightLugagge, luggageStatus) => {
		let luggageStretchText;
		let luggagePrice;
		let stretchName;

		if (flightLugagge === "luggageOutbound" && isDifferentCompanies) {
			luggageStretchText = "de IDA";
			luggagePrice = props.outboundLuggageTotal;
			stretchName = "outbound";
		} else if (flightLugagge === "luggageOutbound" && !isDifferentCompanies) {
			luggageStretchText = "";
			luggagePrice = props.luggageTotal;
			stretchName = "outbound";
		} else {
			luggageStretchText = "de VOLTA";
			luggagePrice = props.inboundLuggageTotal;
			stretchName = "inbound";
		}

		return (
			<div className="values-list__item lugagge-information">
				<span className="values-list__text">
					Bagagem {luggageStretchText}{" "}
					{!isValid(props.notIncluded) && (
						<i
							className="tooltip"
							data-flow="down"
							onClick={() => props.toogleTooltip(stretchName)}
						>
							?
						</i>
					)}
				</span>
				<LuggageTooltip
					key={0}
					childId={0}
					content={{
						airline: props[flightAirline],
						luggage: props[flightLugagge]
					}}
					show={props.showTooltip[stretchName]}
					isInternational={props.isInternational}
				/>
				<span className="values-list__number">
					{isValid(luggagePrice) ? luggagePrice : <strong>{luggageStatus}</strong>}
				</span>
			</div>
		);
	};

	let luggageStatusOutbound, luggageStatusInbound;
	let luggageTypeOutbound, luggageTypeInbound;

	if (hasTwoLuggages && isDifferentCompanies) {
		if (luggageIsValid("luggageOutbound") && luggageIsValid("luggageInbound")) {
			luggageTypeOutbound = setLuggageType("luggageOutbound");
			luggageTypeInbound = setLuggageType("luggageInbound");

			luggageStatusOutbound = setLuggageStatus(luggageTypeOutbound, "luggageOutbound");
			luggageStatusInbound = setLuggageStatus(luggageTypeInbound, "luggageInbound");

			return (
				<div className="luggage-content">
					{returnLuggageLine("airlineOutbound", "luggageOutbound", luggageStatusOutbound)}
					{returnLuggageLine("airlineInbound", "luggageInbound", luggageStatusInbound)}
				</div>
			);
		}
	} else {
		luggageTypeOutbound = setLuggageType("luggageOutbound");
		luggageStatusOutbound = setLuggageStatus(luggageTypeOutbound);

		return (
			<div className="luggage-content">
				{returnLuggageLine("airlineOutbound", "luggageOutbound", luggageStatusOutbound)}
			</div>
		);
	}

	return null;
};

export default OutputLuggageInformation;
